import { Component, OnInit, OnDestroy, HostListener, Optional, Inject } from '@angular/core';
import { INavigationService } from '@pershing/pershing-core';
import { Location } from '@angular/common';

@Component({
    template: ''
})
export class NavigationBaseComponent implements OnDestroy, OnInit {
    menuItems: any[];
    selectedPageId: string;
    linkUrl: string;
    selectedPage: any;
    showPostLogin: boolean = true;
    removedMenuItems: any[] = [];
    constructor(
        protected navigationService: INavigationService,
        protected location: Location,
        @Optional() @Inject('AppSettings') appSettings: any
    ) {
         this.linkUrl = appSettings.postLoginEquiptUrl;
    }

    ngOnInit() {
        this.navigationService.getMenuConfigurations()?.subscribe(
            (data: any[]) => {
                this.menuItems = data;
                let menu: any;
                for (let i = 0; i < data.length; i++) {
                    menu = this.menuItems[i];
                    if (menu.isLink && menu.LinkUrl === '') {
                        let tempmenu, index;
                        tempmenu = menu;
                        index = this.menuItems.indexOf(menu);
                        tempmenu.LinkUrl = this.linkUrl;
                        this.menuItems[index] = tempmenu;
                    }
                }
                this.processMenuItems();
                this.selectedPageId = this.navigationService.getParentPageId();
            }
        );
    }

    processMenuItems() {
        // To be overrided in child component
    }

    public ngOnDestroy() {
        console.log(' In Component Destroy ');
    }

    @HostListener('document:removeFromNavigation', ['$event'])
    onDojoWidgetEvent(evt: CustomEvent): void {
        console.log('Remove from navigation - ', evt.detail);
        const eventDetail = evt.detail;
        if (eventDetail && eventDetail.navLevel) {
            let mainMenu = eventDetail.mainMenu;
            let secondLevelMenu = eventDetail.secondLevelMenu;
            if (eventDetail.navLevel === 2) {
                let mainMenuObj = this.getMainMenuObj(mainMenu);
                this.removeChildMenu(mainMenuObj, secondLevelMenu);
            }
        }
    }

    getMainMenuObj(mainMenu: string): any {
        if (this.menuItems) {
            for (let i = 0; i < this.menuItems.length; i++) {
                if (this.menuItems[i].id === mainMenu) {
                    return this.menuItems[i];
                }
            }
        }
    }

    removeChildMenu(mainMenu: any, childMenu: string) {
        if (mainMenu && mainMenu.children && mainMenu.children.length > 0) {
            for (let i = 0; i < mainMenu.children.length; i++) {
                if (mainMenu.children[i] && mainMenu.children[i].id === childMenu) {
                    mainMenu.children.splice(i, 1);
                    return;
                }
            }
        }
    }
}
